export const LoginRoute = {
  path: '/login',
  name: 'login',
  component: () => import('@/views/aplus/login/index.vue'),
  meta: {
    title: '登录'
  }
};
export const AdminLoginRoute = {
  path: '/',
  name: 'admin-login',
  component: () => import('@/views/admin/login/index.vue'),
  meta: {
    title: '登录'
  }
};

export const ActiviteRoute = {
  path: '/activate',
  name: 'activate',
  component: () => import('@/views/aplus/activate-account/index.vue'),
  meta: {
    title: '激活账号'
  }
};

export const PasswordRoute = {
  path: '/password',
  name: 'password',
  component: () => import('@/views/aplus/forget-password/index.vue'),
  meta: {
    title: '忘记密码'
  }
};

export const aplusRoutes = [
  {
    path: '/',
    component: () => import('@/views/aplus/layout/index.vue'),
    redirect: '/login',
    children: [LoginRoute, ActiviteRoute, PasswordRoute]
  }
];
// export const aplusRoutes = [LoginRoute, ActiviteRoute, PasswordRoute];
export const adminRoutes = [AdminLoginRoute];
